/**
 * Reiner Zaehler laufender /api/*-Anfragen — der einzige Zaehlpunkt fuer
 * die anwendungsweite Aktivitaetsanzeige. Gespeist von
 * sessionFetchInterceptor.ts, der JEDEN /api/*-Aufruf durchlaeuft — sowohl
 * die react-query-Aufrufe als auch die handgeschriebenen fetch()-Aufrufe
 * (z.B. ImportWizardPage). Ein Zaehler allein ueber react-querys
 * useIsFetching() wuerde Letztere uebersehen.
 *
 * Bewusst ohne jede Browser-API, damit es mit `node --test` ohne DOM
 * lauffaehig ist. Die React-Seite (Aktivitaetsanzeige.tsx) bindet das ueber
 * useSyncExternalStore an — deshalb hat subscribe() genau die dafuer
 * erwartete Signatur: listener ist `() => void`, Rueckgabe ist unsubscribe.
 */

let count = 0
const listeners = new Set()

function notify() {
  for (const listener of listeners) listener()
}

/** Eine Anfrage startet. */
export function begin() {
  count += 1
  notify()
}

/**
 * Eine Anfrage ist fertig — egal ob Erfolg, Fehler oder Abbruch (Aufrufer
 * ruft das aus einem finally auf). Faellt nie unter 0: ein ueberzaehliges
 * end() (Bug an anderer Stelle, doppelter Aufruf) darf den Zaehler nicht
 * negativ machen — sonst haengt die Anzeige fuer immer auf "aktiv".
 */
export function end() {
  count = Math.max(0, count - 1)
  notify()
}

/** Aktueller Stand — auch die getSnapshot-Funktion fuer useSyncExternalStore. */
export function getCount() {
  return count
}

/** listener: () => void; Rueckgabe: unsubscribe. Passt direkt zu useSyncExternalStore. */
export function subscribe(listener) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

/** Nur fuer Tests: isoliert aufeinanderfolgende Testfaelle voneinander. */
export function __resetForTests() {
  count = 0
  listeners.clear()
}
